export default "__VITE_ASSET__DUtXBRwl__"